module.exports = __webpack_public_path__ + "assets/img/warrior-name-9472ae44.png";